import { typography } from "@memorang/helpers/font";
import { DefaultTheme } from "react-native-paper";

const customTypography = typography(false, "opensans");
const theme = {
	...DefaultTheme,
	colors: {
		...DefaultTheme.colors,
		border: "rgba(0,0,0,0.12)",
		primary: "#006B5F",
		inverseOnSurface: "#F5EFF7",
		inverseSurface: "#322F35",
		primaryContainer: "#75F8E3",
		white: "#FFFFFF",
		lowConfidenceContainer: "#FFDAD8",
		lowConfidence: "#D66565",
		moderateConfidenceContainer: "#FCE186",
		moderateConfidence: "#DDA53A",
		satisfactoryConfidence: "#9CCC65",
		highConfidenceContainer: "#BBF0B5",
		highConfidence: "#66BB68",
		onPrimary: "#FFFFFF",
		neutral: "rgba(116, 120, 119, 1)",
		answer: {
			selected: {
				border: "#6da3eb",
				background: "rgba(109, 163, 235, 0.15)",
			},
			correct: {
				border: "#66bb67",
				background: "rgba(102, 187, 103, 0.15)",
			},
			incorrect: {
				border: "#d66565",
				background: "rgba(214, 101, 101, 0.15)",
			},
		},
		confidence: {
			high: "#66bb68",
			medium: "#dda53a",
			low: "#d66565",
		},
		onPrimaryContainer: "#00201C",
		secondary: "#4A635E",
		secondaryContainer: "#CCE8E2",
		secondaryContainerHigh: "##ECE6F0",
		onSecondary: "#FFFFFF",
		onSecondaryContainer: "#06201C",
		error: "#BA1A1A",
		errorContainer: "#F2F2F2",
		onError: "#FFFFFF",
		divider: "#F2F2F2",
		onErrorContainer: "#410002",
		tertiary: "#456179",
		tertiaryContainer: "#CBE6FF",
		onTertiary: "#000000",
		onTertiaryContainer: "#001E30",
		background: "#F5F5F5",
		onBackground: "#000000",
		surface: "#FAFAFA",
		onSurface: "#000000",
		surfaceVariant: "#F2F2F2",
		onSurfaceVariant: "#000000",
		text: "#000000",
		info: {
			main: "#0288d1",
			light: "#03a9f4",
			dark: "#01579b",
		},
		progress: {
			high: "#66bb68",
			medium: "#dda53a",
			low: "#d66565",
			none: "#ddd",
			noneBackground: "#888888",
			lowBackground: "rgba(255,105,97, 0.3)",
			highBackground: "rgba(0, 168, 106, 0.3)",
		},
		success: {
			main: "#1AA251",
			light: "#6AE79C",
			dark: "#1AA251",
			info: "rgba(187, 240, 181, 1)",
		},
		black: "#000000",
	},
	palette: {
		primary: {},
		secondary: {},
		upsell: {
			cardText: "#CB3340",
			cardCta: "#CB3340",
		},

		text: {
			primary: "rgba(0,0,0,0.87)",
			secondary: "rgba(0,0,0,0.60)",
			disabled: "rgba(0,0,0,0.38)",
		},
		background: "rgba(255,255,255,0.5)",
		divider: "rgba(0,0,0,0.12)",
		premium: "#CB3340",
		highlight: {
			main: "#FFDACA",
			light: "#F1FF91",
			quote: "#FF8F60",
		},
		yellow: {
			main: "#FBC02D",
			light: "#ffff00",
			dark: "#F57F17",
		},
		confidence: {
			high: "#66bb68",
			medium: "#dda53a",
			low: "#d66565",
		},
		error: {
			main: "#d32f2f",
			light: "#e57373",
			dark: "#c62828",
			info: "rgba(255, 220, 220, 1)",
		},
		success: {
			main: "#1AA251",
			light: "#6AE79C",
			dark: "#1AA251",
			info: "rgba(187, 240, 181, 1)",
		},
		warning: {
			main: "#ed6c02",
			light: "#ff9800",
			dark: "#e65100",
		},
		info: {
			main: "#0288d1",
			light: "#03a9f4",
			dark: "#01579b",
		},
		progress: {
			high: "#66bb68",
			medium: "#dda53a",
			low: "#d66565",
			none: "#ddd",
			noneBackground: "#888888",
			lowBackground: "rgba(255,105,97, 0.3)",
			highBackground: "rgba(0, 168, 106, 0.3)",
		},
		selected: {
			border: "#1e90ff",
			background: "rgba(155, 213, 255, 0.15)",
		},
		answer: {
			selected: {
				border: "#6da3eb",
				background: "rgba(109, 163, 235, 0.15)",
			},
			correct: {
				border: "#66bb67",
				background: "rgba(102, 187, 103, 0.15)",
			},
			incorrect: {
				border: "#d66565",
				background: "rgba(214, 101, 101, 0.15)",
			},
		},
		social: {
			facebookButton: "#3b5998",
			appleButton: "#1c1c1e",
			googleButton: "#4285f4",
		},
		leader: {
			gold: "#FFD336",
		},
		purple: {
			main: "#800080",
			light: "#800080",
			dark: "#4B0082",
		},
		chips: {
			free: "#81C784",
			freeText: "#1B5E20",
			premium: "#FFD700",
			premiumText: "#000000",
		},
		calculator: {
			background: "#2a2a2a",
			displayBackground: "#404040",
			inputTextColor: "#00ff00",
			operationTextColor: "#00ffff",
			resultTextColor: "#ffff00",
			memoryTextColor: "#ff9900",
		},
	},
	breakpoints: {
		xxs: 400,
		xs: 500,
		sm: 840,
		md: 1024,
		lg: 1280,
	},
	typography: customTypography, // biome-ignore lint/suspicious/noExplicitAny: can be generic
	componentOverrides: {} as Record<string, any>,
};

export default theme;
